<div class="rd-widget" *ngIf="(widgetData$ | async) as widgetData">
  <h3>{{title | uppercase}}</h3>
  <div class="map-container">
  </div>
</div>
